<template>
  <v-row justify="space-between" align="center" class="px-3">
    <v-btn
      color="secondary"
      rounded
      elevation="0"
      large
      :disabled="disabledBack"
      outlined
      @click="$emit('click-back')"
    >
      <v-icon class="ml-1">arrow_back</v-icon>
      Voltar
    </v-btn>

    <v-btn
      v-if="showSaveButton"
      color="primary"
      rounded
      elevation="0"
      plain
      small
      :disabled="!canSave"
      @click="$emit('click-save')"
    >
      <v-icon class="mr-1">
        {{ isSaving ? "mdi-cloud-sync" : "mdi-cloud-upload" }}
      </v-icon>
      {{ isSaving ? "Salvando..." : "Salvar" }}
    </v-btn>

    <v-btn
      rounded
      elevation="0"
      large
      color="secondary"
      :disabled="disabledNext"
      :loading="isFinishing"
      @click="$emit('click-next')"
    >
      <template v-if="isLastStep">
        <v-icon v-if="!isFinishing" class="mr-1">check</v-icon>
        {{ isFinishing ? "Finalizando..." : "Finalizar" }}
      </template>
      <template v-else>
        Próximo <v-icon class="ml-1">arrow_forward</v-icon>
      </template>
    </v-btn>
  </v-row>
</template>

<script>
export default {
  name: "StepButtonsTherapy",
  props: {
    disabledNext: {
      type: Boolean,
      default: false,
    },
    disabledBack: {
      type: Boolean,
      default: false,
    },
    isLastStep: {
      type: Boolean,
      default: false,
    },
    showSaveButton: {
      type: Boolean,
      default: false,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
    canSave: {
      type: Boolean,
      default: true,
    },
    isFinishing: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
